var mobile_menu = {
    init: function () {
        $('.navbar-toggler').click(function () {
            console.log('clicked');
            var $target = $('#' + $(this).attr('aria-controls'));
            var isExpanded = $(this).attr('aria-expanded') === 'true';

            // Toggle the aria-expanded state first
            $target.attr('aria-hidden', isExpanded);
            jQuery(this).attr('aria-expanded', !isExpanded);
            
            if (!isExpanded) {
                $('.navbar-toggler').find('i').removeClass('icon-bars').addClass('icon-cross');
                $('.navbar-toggler').addClass('active');
                $target.slideDown(150);
            } else {
                $('.navbar-toggler').find('i').removeClass('icon-cross').addClass('icon-bars');
                $('.navbar-toggler').removeClass('active');
                $target.slideUp(150);
            }
        });

        $(document).on('click', '.mobile-menu-contain li:not([aria-expanded="true"]) .mobile_expander', function (e) {
            console.log('clickedd');
            e.preventDefault();
            $('.mobile-menu-contain li[aria-expanded="true"]').attr('aria-expanded', 'false').find('.sub-menu').slideUp(200);
            let $parent = $(this).parent();
            $(this).siblings('.sub-menu').slideDown(100, function () {
                $parent.attr('aria-expanded', 'true');
            });
        });

        $(document).on('click', '.mobile-menu-contain li[aria-expanded="true"] .mobile_expander', function (e) {
            e.preventDefault();
            $(this).parent().attr('aria-expanded', 'false');
            $(this).siblings('.sub-menu').slideUp(100);
        });
    }
};

jQuery(document).ready(function ($) {
    //console.log('Mobile menu initialized');
    mobile_menu.init();
});